import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { WaIcon } from './Header';
import { trackWhatsAppClick, trackJuegoClick } from '../analytics';
import { STATS, TABLA_NUTRI, PLATOS, GALERIA, PASOS, FAQS } from '../mock';

export const PescadoBarato = () => (
  <section className="pedido" id="pescado-barato" style={{ paddingBottom: 0 }}>
    <div className="wrap">
      <p className="eyebrow">Proteína económica</p>
      <h2 className="sec">Pescado fresco y barato: la proteína más económica del Atlántico</h2>
      <p className="sec-sub">
        Un kilo de cachama fresca cuesta desde $6.000 y rinde 3 o 4 porciones. A ese precio, la proteína de la cachama
        sale más barata que la de la carne de res, el cerdo o el pollo: 18 g de proteína y solo 102 kcal por cada 100 g.
        Es pescado fresco de verdad: se cosecha en la madrugada en nuestra finca en Manatí, se eviscera y se despacha en
        frío el mismo día, con registro INVIMA. Sin intermediarios, por eso podemos dar el mejor precio del kilo de
        pescado en Barranquilla y en los 23 municipios del Atlántico.
      </p>
      <ul className="barato-lista">
        <li><strong>Cachama pequeña:</strong> $6.000/kg — la opción más económica para la familia.</li>
        <li><strong>Cachama mediana:</strong> $8.000/kg — porción individual perfecta.</li>
        <li><strong>Cachama grande:</strong> $10.000/kg — para asar o freír entera.</li>
      </ul>
      <p className="sec-sub" style={{ marginTop: 14 }}>
        Pedido mínimo 2 kg. Domicilio Barranquilla $12.000 (martes y sábados); municipios $30.000; recoger en la finca gratis.
      </p>
    </div>
  </section>
);

export const Nutricion = () => (
  <section className="nutri" id="nutricion">
    <div className="wrap">
      <p className="eyebrow">Nutrición certificada por laboratorio</p>
      <h2 className="sec">18 g de proteína y solo 102 calorías por cada 100 g</h2>
      <p className="sec-sub">
        Hicimos analizar nuestra cachama en laboratorio certificado. El resultado: una proteína completa, magra y
        natural — sin azúcares, baja en sodio y con minerales como hierro, calcio y zinc.
      </p>
      <div className="nutri-grid">
        <div>
          <div className="stats">
            {STATS.map((s) => (
              <div className="stat" key={s.s}><b>{s.b}</b><span>{s.s}</span></div>
            ))}
          </div>
          <details className="ver-tabla">
            <summary>Ver tabla nutricional completa</summary>
            <div>
              <table className="tabla-nutri" aria-label="Información nutricional por 100 gramos">
                <tbody>
                  <tr><th>Información nutricional</th><th style={{ textAlign: 'right' }}>Por 100 g</th></tr>
                  {TABLA_NUTRI.map((r) => (
                    <tr key={r.k} className={r.sub ? 'sub' : ''}><td>{r.k}</td><td>{r.v}</td></tr>
                  ))}
                </tbody>
              </table>
              <p className="fuente">Análisis de tabla nutricional realizado por el laboratorio Mediempresa S.A.S (diciembre de 2025) para Finca Pescado S.A.S. Contiene grasa saturada conforme al rotulado de la Resolución 2492 de 2022.</p>
            </div>
          </details>
        </div>
        <div className="nutri-foto">
          <img
            src="https://d8j0ntlcm91z4.cloudfront.net/user_3GQMdjXI4CC6Kn0Qn4wfm3z7RiO/hf_20260825_220201_b4532048-89b2-4cdb-8442-f2084380b22b.png"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/images/nutri-fallback.jpg'; }}
            alt="Cachama fresca sobre hielo, alta en proteína y baja en calorías"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);

export const Recetas = () => (
  <section className="cocina" id="recetas">
    <div className="wrap">
      <p className="eyebrow">De la finca a tu cocina</p>
      <h2 className="sec">Un pescado, mil formas de disfrutarlo</h2>
      <p className="sec-sub">
        La cachama rinde más y cuesta menos que la mojarra, con mayor valor nutricional. Su carne firme aguanta el
        fogón, la parrilla y la olla — estas son las preparaciones favoritas de la costa.
      </p>
      <div className="cocina-grid">
        <div className="cocina-foto">
          <img
            src="https://d8j0ntlcm91z4.cloudfront.net/user_3GQMdjXI4CC6Kn0Qn4wfm3z7RiO/hf_20260825_220201_86594576-677b-4076-bb58-913643564ea8.png"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/images/cocina-fallback.jpg'; }}
            alt="Cachama asada servida con patacón y arroz de coco, cocina costeña"
            loading="lazy"
          />
        </div>
        <div className="platos">
          {PLATOS.map((p) => (
            <div className="plato" key={p.t}>
              <span className="pico">{p.ico}</span>
              <h3>{p.t}</h3>
              <p>{p.p}</p>
            </div>
          ))}
        </div>
      </div>
      <p style={{ marginTop: 26 }}>
        <a className="btn btn-wa" href="https://wa.me/573106846758?text=Hola%20Finca%20Pescado%2C%20quiero%20pedir%20cachama%20fresca%20para%20cocinar" target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('recetas')}>
          <WaIcon /> Pide la tuya por kilos
        </a>
      </p>
    </div>
  </section>
);

export const Certificaciones = () => (
  <section className="certs" id="calidad">
    <div className="wrap">
      <p className="eyebrow">Calidad con respaldo oficial</p>
      <h2 className="sec">Registro INVIMA y análisis de laboratorio</h2>
      <div className="cert-grid">
        <div className="cert">
          <span className="sello">✓ INVIMA</span>
          <h3>Registro Sanitario vigente</h3>
          <p>Nuestro pescado eviscerado cuenta con Registro Sanitario del INVIMA (Instituto Nacional de Vigilancia de Medicamentos y Alimentos), que nos autoriza a fabricar y vender bajo la marca Finca Pescado SAS con vigencia de 5 años.</p>
          <p style={{ marginTop: 10 }}><span className="dato">RSA-3097-2025</span><br /><small>Resolución No. 2025054558 del 27 de octubre de 2025</small></p>
        </div>
        <div className="cert">
          <span className="sello">✓ LABORATORIO</span>
          <h3>Tabla nutricional certificada</h3>
          <p>La composición nutricional de nuestra cachama fue analizada y certificada por el laboratorio de alimentos Mediempresa S.A.S en Medellín: 18 g de proteína y 102 kcal por cada 100 g, sin azúcares y baja en sodio.</p>
          <p style={{ marginTop: 10 }}><span className="dato">Análisis certificado</span><br /><small>Mediempresa S.A.S · Diciembre de 2025</small></p>
        </div>
      </div>
    </div>
  </section>
);

export const Galeria = () => (
  <section className="gal" id="cachama">
    <div className="wrap">
      <p className="eyebrow">Nuestra cachama</p>
      <h2 className="sec">Carne firme, color vivo, frescura de verdad</h2>
      <p className="sec-sub">La cachama es un pescado de agua dulce de carne suave y sabrosa, favorito de la costa. Así se ve la nuestra el día de la cosecha.</p>
      <div className="gal-grid">
        {GALERIA.map((g) => (
          <figure key={g.img}>
            <img src={g.img} alt={g.alt} loading="lazy" />
            <figcaption>{g.cap}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export const Proceso = () => (
  <section className="proceso" id="proceso">
    <div className="wrap">
      <p className="eyebrow">Frescura que se puede ver</p>
      <h2 className="sec">Así llega la cachama del agua a tu casa</h2>
      <p className="sec-sub">Estas fotos son de nuestra propia operación. Cada jornada sigue el mismo protocolo, y por eso el pescado llega con la frescura del día.</p>
      <div className="pasos">
        {PASOS.map((p) => (
          <article className="paso" key={p.num}>
            <img src={p.img} alt={p.alt} loading="lazy" />
            <div>
              <span className="num">{p.num}</span>
              <h3>{p.t}</h3>
              <p>{p.p}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export const Finca = () => (
  <section className="finca">
    <div className="wrap">
      <p className="eyebrow">Quiénes somos</p>
      <div className="finca-grid">
        <div>
          <h2 className="sec">Peces sanos gracias al sistema IPRS de canales</h2>
          <p>En Finca Pescado S.A.S cultivamos cachama en Manatí, Atlántico, con el sistema IPRS (Intensive Pond Raceway System): canales por donde el agua corre de forma constante, como en un río. El agua nunca está quieta — se oxigena, se renueva y arrastra los desechos fuera del canal.</p>
          <p>Como los peces viven en agua limpia y en movimiento, se mantienen sanos de forma natural: <strong>sin químicos ni medicamentos</strong>. Solo agua corriendo, buena alimentación y control diario de oxígeno, pH y temperatura.</p>
          <p>El resultado es una carne firme, de sabor limpio, que no se compara con el pescado que lleva semanas congelado. Y la vendemos directo, sin intermediarios: de la finca a tu casa en la ciudad.</p>
        </div>
        <img src="/images/finca.jpg" alt="Cachama recién cosechada en la alberca de frío de Finca Pescado" loading="lazy" />
      </div>
    </div>
  </section>
);

export const Cobertura = () => (
  <section className="cob" id="cobertura">
    <div className="wrap">
      <p className="eyebrow">Domicilios</p>
      <h2 className="sec">¿Dónde entregamos?</h2>
      <div className="cob-grid">
        <div className="zona"><h3>Barranquilla y alrededores</h3><p>Ruta programada de entregas los <strong>martes y sábados</strong> (pedidos agrupados). Domicilio: <strong>$12.000</strong>. Te confirmamos la franja de entrega por WhatsApp.</p></div>
        <div className="zona"><h3>Manatí y municipios del Atlántico</h3><p>Entregamos en Manatí y municipios cercanos del Atlántico (domicilio $30.000). También puedes recoger tu pedido directamente en la finca, sin costo.</p></div>
      </div>
      <div className="zonas-lista" data-testid="zonas-lista">
        <h3>Zonas de entrega</h3>
        <p>
          Barranquilla, Soledad, Malambo, Puerto Colombia, Galapa, Baranoa, Sabanalarga, Sabanagrande, Santo Tomás,
          Palmar de Varela, Ponedera, Manatí, Candelaria, Campo de la Cruz, Suan, Repelón, Luruaco, Usiacurí, Tubará,
          Juan de Acosta, Piojó, Polonuevo y Santa Lucía.
        </p>
      </div>
      <p style={{ marginTop: 22, color: 'var(--tinta-2)' }}>
        ¿Tu zona no aparece? Escríbenos por WhatsApp y buscamos la forma de llegar:{' '}
        <a href="https://wa.me/573106846758" target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('zonas')}><strong>310 684 6758</strong></a>.
      </p>
    </div>
  </section>
);

export const Faq = () => (
  <section className="faq" id="faq">
    <div className="wrap">
      <p className="eyebrow">Preguntas frecuentes</p>
      <h2 className="sec">Antes de pedir</h2>
      {FAQS.map((f) => (
        <details key={f.q}>
          <summary>{f.q}</summary>
          <p>{f.a}</p>
        </details>
      ))}
    </div>
  </section>
);

const JUEGOS_HOME = [
  { id: 'guajaro', titulo: 'Juega: Pescando Cachamas en el Guájaro', texto: 'Rema al atardecer por el embalse, atrapa cachamas y esquiva los troncos. ¿Hasta dónde llegas antes de que caiga la noche?', href: '/guajaro/index.html' },
  { id: 'cosecha_iprs', titulo: 'Cosecha en el Canal IPRS', texto: 'Acorrala las cachamas con la malla en cinco canales y sácalas con el aro de pesca antes de que se acabe el tiempo.', href: '/cosecha/index.html' },
  { id: 'comer', titulo: 'Hora de Comer', texto: 'Alimenta las cachamas del canal sin botar alimento por la malla ni subir el amoníaco.', href: '/comer/index.html' },
  { id: 'oxigeno', titulo: 'Guardián del Oxígeno', texto: 'Turno de noche: aireadores disparados, mallas tapadas y apagones. Que ninguna cachama se quede sin aire.', href: '/oxigeno/index.html' },
  { id: 'garzas', titulo: '¡Fuera, Garzas!', texto: 'Espanta garzas, patos yuyo y águilas pescadoras antes de que se lleven las cachamas.', href: '/garzas/index.html' },
  { id: 'domicilio', titulo: 'Domicilio a Barranquilla', texto: 'Lleva 60 kg de cachama en hielo de Manatí a Barranquilla esquivando huecos, vacas y mototaxis.', href: '/domicilio/index.html' },
];

export const Juego = () => (
  <section className="pedido" id="juego">
    <div className="wrap">
      <p className="eyebrow">Diversión de la finca</p>
      <h2 className="sec">Juegos de Finca Pescado</h2>
      <p className="sec-sub">
        Juega, guarda tu puntaje con tu nombre y compite en la{' '}
        <a href="/juego" style={{ fontWeight: 700 }}>tabla de clasificación</a>.
      </p>
      <div className="juegos-grid">
        {JUEGOS_HOME.map((j) => (
          <div className="juego-card" key={j.id}>
            <h3>{j.titulo}</h3>
            <p>{j.texto}</p>
            <a
              className="btn btn-stripe"
              style={{ width: 'auto', marginTop: 0 }}
              href={j.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackJuegoClick(j.id === 'cosecha_iprs' ? 'cosecha_iprs' : j.id)}
              data-testid={`btn-jugar-${j.id}`}
            >
              <Gamepad2 size={20} /> Jugar ahora
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);